// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_fH","advertCardList_max6":"c-a_fJ"};